import { Analytics } from '@cobliteam/analytics';

import Icon from '@cobliteam/ui/icons';

import Badge from '@cobliteam/ui/components/Badge';
import Button from '@cobliteam/ui/components/Button';
import Tag from '@cobliteam/ui/components/Tag';

export interface SidebarButtonProps {
  isSidebarOpen: boolean;
  totalSelectedGroups: number;
}

export const SidebarButton = ({ isSidebarOpen, totalSelectedGroups }: SidebarButtonProps) => {
  const shouldRenderBadge = totalSelectedGroups > 0;

  const onDropdownOpen = () => {
    Analytics.track('Global Filter Opened');
  };

  const renderOpenSidebarButton = () => {
    return (
      <Button
        onClick={onDropdownOpen}
        className='flex w-56 items-center justify-between border-white bg-transparent px-2 text-white hover:bg-transparent hover:text-white active:bg-transparent'
        variant='outlined'
      >
        <div className='flex flex-row items-center'>
          <Icon name='car-front' className='mr-2 size-4' />
          Grupo de Veículos
        </div>
        <div className='flex flex-row items-center'>
          {shouldRenderBadge && <Tag label={`${totalSelectedGroups}`} variant='surface' color='primary' size='condensed' />}
          <Icon name='chevron-down' className='ml-1 size-4' />
        </div>
      </Button>
    );
  };

  const CollapsedSidebarIcon = () => {
    return (
      <Badge content={totalSelectedGroups} color='primary' variant='contained' hide={!shouldRenderBadge}>
        <div className='w-full px-1.5 py-1'>
          <Icon name='car-front' className='size-4' />
        </div>
      </Badge>
    );
  };

  const renderCollapsedSidebarButton = () => {
    return (
      <div className='relative inline-block w-24'>
        <Button
          onClick={onDropdownOpen}
          className='w-full text-white hover:bg-white-a2 hover:text-white hover:transition-none'
          variant='text'
          icon={<CollapsedSidebarIcon />}
          full
        />
      </div>
    );
  };

  return isSidebarOpen ? renderOpenSidebarButton() : renderCollapsedSidebarButton();
};
